import React, { useState } from "react";
import UserList from "./UserList";
import ChatRoom from "./ChatRoom";
import UserProfile from "./UserProfile";
import { auth } from "./firebase";

function MainChat({ currentUser }) {
  const [selectedUser, setSelectedUser] = useState(null);
  const [showProfile, setShowProfile] = useState(false);

  const handleLogout = async () => {
    await auth.signOut();
  };

  return (
    <div style={{ display: "flex", height: "100vh" }}>
      {/* Sidebar */}
      <div
        style={{
          width: "250px",
          borderRight: "1px solid #ccc",
          padding: "10px",
        }}
      >
        <div style={{ textAlign: "center", marginBottom: "20px" }}>
          <img
            src={currentUser.photoURL || "https://via.placeholder.com/100"}
            alt="avatar"
            style={{ width: "100px", height: "100px", borderRadius: "50%" }}
          />
          <h4>{currentUser.displayName || currentUser.email}</h4>

          <div style={{ marginTop: "10px" }}>
            <button
              onClick={() => {
                setShowProfile(!showProfile);
                setSelectedUser(null);
              }}
              style={{ marginRight: "10px", padding: "5px 10px" }}
            >
              {showProfile ? "Back" : "Edit Profile"}
            </button>
            <button onClick={handleLogout} style={{ padding: "5px 10px" }}>
              Logout
            </button>
          </div>
        </div>

        {showProfile ? (
          <UserProfile />
        ) : (
          <UserList onSelectUser={setSelectedUser} />
        )}
      </div>

      {/* Chat area */}
      {selectedUser && !showProfile ? (
        <ChatRoom currentUser={currentUser} otherUser={selectedUser} />
      ) : (
        !showProfile && (
          <div
            style={{
              flex: 1,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <h2>Select a user to chat</h2>
          </div>
        )
      )}
    </div>
  );
}

export default MainChat;
